export const TemporaryAssistanceMotive = [
  { value: null, text: "Selecione o motivo", disabled: true },
  { value: "Acidente Pessoal", text: "Acidente Pessoal" },
  { value: "Doença", text: "Doença" },
  { value: "Licença Maternidade", text: "Licença Maternidade" },
];
